var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "d-flex align-items-center" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.localSearchStr,
            expression: "localSearchStr",
          },
        ],
        staticClass: "form-control me-2",
        attrs: { placeholder: "Search...", type: "text" },
        domProps: { value: _vm.localSearchStr },
        on: {
          keyup: _vm.onChange,
          keypress: (event) => event.which === 13 && _vm.fetchPage(),
          input: function ($event) {
            if ($event.target.composing) return
            _vm.localSearchStr = $event.target.value
          },
        },
      }),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-primary",
          on: {
            click: function ($event) {
              return _vm.fetchPage()
            },
          },
        },
        [_c("i", { staticClass: "fas fa-search" })]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "text-muted pb-3 c-text-sm" }, [
      _vm._v(
        "Wrap phrase in quotation marks if needed, use + sign for multiple words."
      ),
    ]),
    _vm._v(" "),
    Object.keys(_vm.filter).length > 0
      ? _c("div", { staticClass: "mb-3" }, [
          _c(
            "div",
            { staticClass: "d-flex flex-wrap gap-1" },
            _vm._l(_vm.filter, function (value, key) {
              return _c(
                "div",
                {
                  key: key,
                  staticClass: "badge rounded-pill btn text-bg-primary",
                },
                [
                  _vm._v("\n        " + _vm._s(value) + "\n        "),
                  _c(
                    "span",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.deleteFilter(key)
                        },
                      },
                    },
                    [_c("i", { staticClass: "fas fa-times" })]
                  ),
                ]
              )
            }),
            0
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "d-flex justify-content-center gap-2 mb-3" },
      _vm._l(_vm.itemTypes, function (itemType) {
        return _c(
          "button",
          {
            key: itemType.value,
            staticClass: "btn btn-sm btn-dark",
            class: [
              "item-type-btn",
              { active: _vm.filter.item_type === itemType.value },
            ],
            on: {
              click: function ($event) {
                return _vm.addFilter("item_type", itemType.value)
              },
            },
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(itemType.label) +
                " (" +
                _vm._s(itemType.count) +
                ")\n    "
            ),
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    _vm.loading
      ? _c("div", { staticClass: "text-center py-4" }, [
          _c("i", { staticClass: "fas fa-spinner fa-spin" }),
          _vm._v(" Laden...\n  "),
        ])
      : _vm.error
      ? _c("div", { staticClass: "alert alert-danger" }, [
          _vm._v("\n    " + _vm._s(_vm.error) + "\n  "),
        ])
      : _c(
          "div",
          [
            _c("div", { staticClass: "mb-3" }, [
              _vm._v(
                "\n      " + _vm._s(_vm.pager.totalHits) + " Treffer\n      "
              ),
              _vm.localSearchStr
                ? _c("span", [
                    _vm._v('für "' + _vm._s(_vm.localSearchStr) + '"'),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _vm._l(_vm.items, function (item) {
              return _c(
                "div",
                { key: item.id, staticClass: "c-search-result" },
                [
                  _c("a", { attrs: { href: item.url } }, [
                    _c("h5", {
                      staticClass: "mb-0",
                      domProps: { innerHTML: _vm._s(item.repr) },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("small", { staticClass: "text-sm text-grey" }, [
                    _vm._v(_vm._s(item.pub_date)),
                  ]),
                  _vm._v(" "),
                  item.author
                    ? _c("span", [
                        _c(
                          "a",
                          {
                            staticClass:
                              "badge rounded-pill text-bg-light border text-decoration-none",
                            attrs: { href: "" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.addFilter("author", item.author)
                              },
                            },
                          },
                          [_vm._v("@" + _vm._s(item.author))]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  item.topic
                    ? _c("span", [
                        _c(
                          "a",
                          {
                            staticClass:
                              "badge rounded-pill text-bg-light border text-decoration-none",
                            attrs: { href: "" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.addFilter("topic", item.topic)
                              },
                            },
                          },
                          [_vm._v("§" + _vm._s(item.topic))]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(item.categories, function (category) {
                    return _c("span", { key: category }, [
                      _c(
                        "a",
                        {
                          staticClass:
                            "badge rounded-pill text-bg-light border text-decoration-none me-1",
                          attrs: { href: "" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.addFilter("categories", category)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n          " + _vm._s(category) + "\n        "
                          ),
                        ]
                      ),
                    ])
                  }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "mt-2",
                    domProps: { innerHTML: _vm._s(item.text) },
                  }),
                  _vm._v(" "),
                  _c("hr"),
                ],
                2
              )
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "d-flex flex-row align-items-center justify-content-center gap-2",
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-dark",
                    attrs: { disabled: !_vm.pager.previous },
                    on: {
                      click: function ($event) {
                        return _vm.previousPage()
                      },
                    },
                  },
                  [_c("i", { staticClass: "bi bi-chevron-left" })]
                ),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.pager.currentPage) +
                      " / " +
                      _vm._s(_vm.pager.totalPages) +
                      "\n      "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-dark",
                    attrs: { disabled: !_vm.pager.next },
                    on: {
                      click: function ($event) {
                        return _vm.nextPage()
                      },
                    },
                  },
                  [_c("i", { staticClass: "bi bi-chevron-right" })]
                ),
              ]
            ),
          ],
          2
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }